/**
 * @ngdoc services
 * @memberof mercury.modules.settings
 * @name Company
 * @description Data access service for users view invoices
 */
angular.module('mercury.modules.settings.company')
.factory('LoadedInvoice', ["$http", "settings", function($http, settings) {

  /**
   * Get all companies the current user has access to
   *
   * @memberof Company
   */
  function getAll(subscriptionId, page, pageSize) {
    if (!page) { page = 0; }
    if (!pageSize) { pageSize = 0; }
    return $http.get(settings.apiHost + '/r/LoadedInvoices', {params: {page: page, pageSize: pageSize}});
  }

  return {
    getAll: getAll
  };
}]);
